import axios from "axios";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router";
import { checkAndRedirectByRole } from "../utils/authUtils";
import Navbar from "../constants/Navbar";
import { Check } from "lucide-react";
import { useAlert } from "../constants/AlertProvider";
import { RolePopup } from "../components/common/RolePopup";

export default function LandingPage() {
    const navigate = useNavigate();
    const showAlert = useAlert();
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedRecRole, setSelectedRecRole] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    useEffect(() => {
        //check authentication
        checkAndRedirectByRole(navigate);
    }, [navigate]);

    const handleRoleSelect = (role) => {
        setSelectedRole(role);
        if (role === 'hiring') {
            setIsPopupOpen(true);
        }
    };

    const handlePopupContinue = (hiringRole) => {
        setIsPopupOpen(false);
        if (hiringRole === 'organization') {
            setSelectedRecRole('recruiter');
            navigate('/recsignup', { state: { recRole: 'recruiter' } });
        } else if (hiringRole === 'sme') {
            setSelectedRecRole('smallbiz_owner');
            navigate('/recsignup', { state: { recRole: 'smallbiz_owner' } });
        }
    };

    const handleSubmit = () => {
        if (!selectedRole) {
            showAlert("Please select an option to continue", "error");
            return;
        }

        if (selectedRole === "candidate") {
            navigate("/signup");
        }

        if (selectedRole === "hiring") {
            setIsPopupOpen(true);
        }
    };

    return (
        <>
            <Navbar />
            <RolePopup
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
                onContinue={handlePopupContinue}
            />
            <div className="min-h-screen bg-white dark:bg-gray-900 flex flex-col">
                <div className="w-full bg-gradient-to-r from-[#FF80B5] via-white to-[#9089FC] mb-8">
                    <div className="w-full px-4 py-6 sm:p-6 flex justify-center items-center bg-gray-50/90 dark:bg-gray-800/90 backdrop-blur-2xl">
                        <h1 className="text-2xl sm:text-[32px] font-bold text-gray-900 dark:text-gray-100 tracking-tighter text-center">Join as a talent or recruiter</h1>
                    </div>
                </div>
                <div className="flex flex-col items-center justify-center gap-y-8 px-4">
                    <div className="w-full max-w-3xl flex flex-col sm:flex-row gap-6 justify-center items-center">
                        {[
                            { value: "hiring", label: "I’m hiring for a project" },
                            { value: "candidate", label: "I’m looking for work" }
                        ].map(option => (
                            <label key={option.value} className="relative w-full sm:flex-1 cursor-pointer">
                                <button
                                    onClick={() => handleRoleSelect(option.value)}
                                    className="w-full h-[120px] sm:h-[144px] flex items-center justify-center rounded-lg border-2 p-4 text-center shadow-sm hover:bg-gray-100 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800"
                                >
                                    <span className="font-bold text-gray-900 dark:text-gray-100 text-xl sm:text-2xl tracking-tighter">
                                        {option.label}
                                    </span>
                                    <span
                                        className={`absolute top-2 right-2 w-6 h-6 ${selectedRole === option.value ? "bg-blue-700" : "bg-white dark:bg-gray-800"} border border-gray-400 dark:border-gray-500 rounded-full flex items-center justify-center`}
                                    >
                                        {selectedRole === option.value && <Check className="w-4 h-4 text-white" strokeWidth={3} />}
                                    </span>
                                </button>
                            </label>
                        ))}
                    </div>

                    <button onClick={handleSubmit} type="submit" disabled={!selectedRole} className="w-auto px-10 h-[48px] rounded-lg bg-blue-700 text-white font-semibold text-sm hover:bg-blue-600 shadow-sm disabled:bg-blue-300 disabled:cursor-not-allowed">
                        Continue
                    </button>

                    <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
                        Already have an account?{" "}
                        <Link to="/login" className="text-blue-500 font-semibold hover:text-blue-600 transition-colors duration-200">
                            Login
                        </Link>
                    </p>
                </div>
            </div>
        </>
    );

}
